export default __webpack_public_path__ + "66e2037965910b418e0eadc71c957455.svg";